<template>
  <flyover-wrapper
    class="feed-manager__flyover"
    :selected-row-info="selectedRowInfo"
    :flyover-tabs="flyoverTabs"
    @tabClick="selectedFlyoverTab"
    @closeFlyover="closeFlyover"
  >
    <mds-loader class="loader" v-if="loader" />
    <component
      v-else
      class="feed-manager__flyover-content"
      v-bind="flyoverProperties[true]"
      :is="flyoverComponent"
      v-on="$listeners"
    />
  </flyover-wrapper>
</template>

<script>
import FlyoverWrapper from './FlyoverWrapper.vue'
import MdsLoader from '@mds/loader'
import isEmpty from 'lodash/isEmpty'
import {
  PARAMETER_NAMES,
  DELIVERY_DESTINATION,
} from '@/components/schedulerModal/config/constants'
import {
  TAB_COMPONENTS,
  TAB_NAMES,
  VIEWS,
  TRIGGER_TYPES,
} from './config/constants'

export default {
  name: 'FlyOver',
  components: {
    FlyoverWrapper,
    MdsLoader,
  },
  props: {
    flyoverTabs: {
      type: Array,
      default: () => [],
    },
    selectedRowInfo: {
      type: Object,
      default: () => ({}),
    },
    view: {
      type: String,
      default: '',
    },
    flyoverProvider: {
      type: Object,
    },
    showFlyover: Boolean,
    loadingFlyover: {
      type: Boolean,
      default: true,
    },
    reloadSchedulesTab: Boolean,
  },
  data() {
    return {
      currentFlyoverTab: {},
      generalDisplayItems: [],
      schedules: [],
      activityLogs: [],
      tabComponents: TAB_COMPONENTS,
      tabNames: TAB_NAMES,
      loader: this.loadingFlyover,
      emptyResponse: false,
    }
  },
  watch: {
    selectedRowInfo: {
      inmediate: true,
      deep: true,
      async handler() {
        this.currentFlyoverTab = this.flyoverTabs.find(
          (tab) => tab.id === this.tabNames.general
        )
      },
    },
    reloadSchedulesTab: {
      async handler() {
        if (this.reloadSchedulesTab) {
          await this.selectedFlyoverTab(this.currentFlyoverTab)
        }
      },
    },
  },
  computed: {
    flyoverComponent() {
      return this.currentFlyoverTab.component
    },
    flyoverProperties() {
      if (this.flyoverComponent) {
        return {
          [this.flyoverComponent.name === this.tabComponents.general]: {
            parameters:
              this.selectedRowInfo.notebook_parameters || this.selectedRowInfo,
            displayItems: this.generalDisplayItems,
            view: this.view,
            name: this.selectedRowInfo.name,
          },
          [this.flyoverComponent.name === this.tabComponents.schedules]: {
            schedules: this.schedules,
            feedId: this.selectedRowInfo.id.toString(),
            view: this.view,
            emptyResponse: this.emptyResponse,
          },
          [this.flyoverComponent.name === this.tabComponents.activityLog ||
          this.flyoverComponent.name === this.tabComponents.exportActivityLog]:
            {
              activityLogs: this.activityLogs,
              view: this.view,
              emptyResponse: this.emptyResponse,
            },
        }
      }
      return {}
    },
  },
  methods: {
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    mappedInvestments(parameters) {
      this.generalDisplayItems = parameters
        .filter((param) => PARAMETER_NAMES.includes(param.name))
        .map((filter_param) => {
          let mergedOptions = []
          for (const property in filter_param.options) {
            let options_result = []
            if (filter_param.name.toLowerCase() === DELIVERY_DESTINATION) {
              options_result = filter_param.options[property].ftps
            } else {
              options_result = filter_param.options[property].user.concat(
                filter_param.options[property].morningstar
              )
            }
            mergedOptions = mergedOptions.concat(options_result)
          }
          return {
            name: filter_param.name,
            options: mergedOptions,
          }
        })
    },
    async selectedFlyoverTab(event) {
      this.currentFlyoverTab = event
      this.loader = true
      await this.delay(500)
      this.view === VIEWS.feeds
        ? await this.setFeedsInfo(event)
        : await this.setSchedulesInfo(event)
      this.loader = false
    },
    async setFeedsInfo(event) {
      switch (event.id) {
        case this.tabNames.general:
          await this.loadGeneralTab()
          break
        case this.tabNames.schedules:
          await this.loadSchedulesTab()
          break
        case this.tabNames.exportActivityLog:
          await this.loadActivityLogs()
          break
      }
    },
    async loadGeneralTab() {
      let parameters = []
      if (this.showFlyover) {
        parameters = await this.$store.dispatch(
          'getNotebookParameters',
          this.selectedRowInfo.notebook_id
        )
      }
      this.mappedInvestments(parameters)
    },
    async loadSchedulesTab() {
      this.schedules = await this.flyoverProvider.getSchedulesByFeedId(
        this.selectedRowInfo.id
      )
      this.emptyResponse = isEmpty(this.schedules)
    },
    async loadActivityLogs() {
      const activities = await this.flyoverProvider.getActivityLogs(
        this.selectedRowInfo.id
      )
      this.activityLogs = activities.filter(
        (activity) => activity.trigger_type === TRIGGER_TYPES.api
      )
      this.emptyResponse = isEmpty(this.activityLogs)
    },
    async setSchedulesInfo(event) {
      if (event.id === this.tabNames.activityLog) {
        this.activityLogs = await this.$store.dispatch('getActivityLogs', {
          feedId: this.selectedRowInfo.feedId,
          scheduleId: this.selectedRowInfo.id,
        })
        this.emptyResponse = isEmpty(this.activityLogs)
      }
    },
    async closeFlyover() {
      this.$emit('closeFlyover')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.loader {
  &::v-deep [class^='mds-loader__item'] {
    top: 50%;
  }
}
</style>
